<body id="page-top">

    <div id="wrapper" [class.full-width-mode]="!sidebarVisible">
        <!-- sidebar -->
        <app-main-sidebar></app-main-sidebar>
        <!-- /sidebar -->

        <div id="content-wrapper" class="d-flex flex-column">

            <!-- main -->
            <div id="content">

                <!-- main nav -->
                <app-main-nav></app-main-nav>
                <!-- /man nav -->

                <!-- content -->
                <div class="container-fluid">
                    <router-outlet></router-outlet>
                </div>
                <!-- /content -->

                <!--Floating button-->
                <app-back-button />
                <button *ngIf="!readOnlyView && (level==99 ||  (sendProg>0 || sendInme>0))" class="btn btn-warning rounded-circle position-fixed btn-send" (click)="openModal(addSheduled,'xl')"
                    style="bottom: 40px; right: 40px;">
                    <i class="fas fa-paper-plane"></i>
                </button>
                <!--/floating button-->
            </div>
            <!-- main -->

            <!-- footer -->
            <app-main-footer></app-main-footer>
            <!-- /footer -->

        </div>

    </div>
</body>
<ng-template #addSheduled let-c="close " let-d="dismiss" >
    <div class="modal-body shadow-lg">
        <app-add-scheduled-rounds  />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
